<template>
<div>
    <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert_success" v-if="alert_show_add === true">เพิ่มฟอร์มขออนุญาติลางานเรียบร้อย</v-alert>
        <v-alert type="success" class="alert_success" v-if="alert_show_edit === true">แก้ไขฟอร์มขออนุญาติลางานเรียบร้อย</v-alert>
        <v-alert type="success" class="alert_success" v-if="alert_show_delete === true">ลบฟอร์มขออนุญาติลางานเรียบร้อย</v-alert>
    </v-slide-x-reverse-transition>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <div class="mb-2">
            <h2>การลางาน ประจำปี {{ new Date().getFullYear() + 543 }}</h2>
        </div>
        <div class="grid_leave_work_list mb-2">
            <v-card class="pa-3 mb-2 mr-1 d-flex justify-space-between white--text" color="error">
                <div>ลาป่วย</div>
                <div>{{ sick_leave_num }} วัน</div>
            </v-card>
            <v-card class="pa-3 mb-2 ml-1 d-flex justify-space-between white--text" color="warning">
                <div>ลากิจ</div>
                <div>{{ leave_num }} วัน</div>
            </v-card>
            <v-card class="pa-3 mb-2 mr-1 d-flex justify-space-between white--text" color="info">
                <div>ลาคลอด</div>
                <div>{{ leave_givingbirth_num }} วัน</div>
            </v-card>
        </div>
        <div class="mb-2 text-right">
            <v-btn class="grad-primary-bg white--text" @click="openAddLeaveWork()" width="20%" height="65">
                ฟอร์มขออนุญาติลา
            </v-btn>
        </div>
        <v-card>
            <v-card-title>
                <v-text-field v-model="search" color="primary" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
            </v-card-title>
            <v-data-table :headers="headers" :items="data" :search="search">
                <template v-slot:item="dataDetail">
                    <tr>
                        <td>{{dataDetail.item.number}}</td>
                        <td>{{dataDetail.item.type}}</td>
                        <td>{{dataDetail.item.start_date}}</td>
                        <td>{{dataDetail.item.end_date}}</td>
                        <td>{{dataDetail.item.description}}</td>
                        <td>
                            <div :class="dataDetail.item.status == 'รออนุมัติ' ? 'warning--text' : dataDetail.item.status == 'ไม่อนุมัติ' ? 'error--text' : 'success--text'">
                                {{ dataDetail.item.status }}
                            </div>
                        </td>
                        <td v-if="dataDetail.item.status == 'รออนุมัติ'">
                            <span class="cursor_leave_work_list" @click="openEditLeaveWork(dataDetail.item.id)">
                                <v-icon right color="grey">mdi-pencil-box-outline</v-icon>
                            </span>
                            <span class="cursor_leave_work_list" @click="openDeleteLeaveWork(dataDetail.item.id)">
                                <v-icon right color="grey">mdi-delete</v-icon>
                            </span>
                        </td>
                        <td v-if="dataDetail.item.status != 'รออนุมัติ'">
                            <span class="cursor_leave_work_list" @click="openDetailLeaveWork(dataDetail.item.id)">
                                <v-icon right color="grey">mdi-eye</v-icon>
                            </span>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-card>
        <!-- รายละเอียด -->
        <v-dialog v-model="open_detail_leave_work" persistent max-width="600px">
            <div v-if="loading_page_detail === true">
                <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                    <v-skeleton-loader type="article, actions"></v-skeleton-loader>
                </v-sheet>
            </div>
            <v-card v-if="loading_page_detail === false">
                <v-card-title class="justify-space-between">
                    <div>
                        รายละเอียดฟอร์มขออนุญาติลา
                    </div>
                    <div class="cursor_leave_work_list" @click="open_detail_leave_work = false">
                        <v-icon>mdi-close</v-icon>
                    </div>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <div class="height_full_detail_leave_work_list">

                                    <div class="title_font_leave_work mb-2">
                                        ประเภทการลา : <span :class="type_leave == 1 ? 'warning--text' : type_leave == 2 ? 'error--text' : type_leave == 3 ? 'info--text' : ''">{{ type_leave == 1 ? 'ลากิจ' : type_leave == 2 ? 'ลาป่วย' : type_leave == 3 ? 'ลาคลอด' : '' }}</span>
                                    </div>
                                    <div class="title_font_leave_work mb-2">
                                        วันลา : {{ date_start_edit_be }} - {{ date_end_edit_be }}
                                    </div>

                                    <div class="title_font_leave_work mb-2">
                                        เหตุผลการลา : {{ description }}
                                    </div>
                                    <div class="title_font_leave_work mb-2">
                                        สถานะ : <span :class="status_detail == 1 ? 'warning--text' : status_detail == 2 ? 'success--text' : status_detail == 3 ? 'error--text' : ''">{{ status_detail == 1 ? 'รออนุมัติ' : status_detail == 2 ? 'อนุมัติ' : status_detail == 3 ? 'ไม่อนุมัติ' : '' }}</span>
                                    </div>
                                </div>
                            </v-col>

                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions class="justify-center">

                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- เพิ่ม -->
        <v-dialog v-model="open_add_leave_work" persistent max-width="600px">
            <v-card>
                <v-form ref="form_add" @submit.prevent="addLeaveWork()">
                    <v-card-title class="justify-space-between">
                        <div>
                            ฟอร์มขออนุญาติลา
                        </div>
                        <div class="cursor_leave_work_list" @click="open_add_leave_work = false">
                            <v-icon>mdi-close</v-icon>
                        </div>
                    </v-card-title>

                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12">
                                    <div class="title_font_leave_work mb-2">
                                        ประเภทการลา
                                    </div>
                                    <div class="mb-2">
                                        <v-radio-group class="mt-0" v-model="type_leave" :rules="[v => !!v || 'กรุณาเลือกประเภทการลา']" required hide-details="auto">
                                            <div class="d-flex">
                                                <div class="d-flex">
                                                    <v-radio color="#038cc1" class="mb-0" value="1"></v-radio>
                                                    <div class="mr-1">ลากิจ</div>
                                                </div>
                                                <div class="d-flex mx-4">
                                                    <v-radio color="#038cc1" class="mb-0" value="2"></v-radio>
                                                    <div class="mr-1">ลาป่วย</div>
                                                </div>
                                                <div class="d-flex">
                                                    <v-radio color="#038cc1" class="mb-0" value="3"></v-radio>
                                                    <div class="mr-1">ลาคลอด</div>
                                                </div>

                                            </div>
                                        </v-radio-group>
                                    </div>
                                    <div class="title_font_leave_work mb-2">
                                        วันลา
                                    </div>
                                    <div class="grid_leave_work_list">
                                        <v-menu ref="menu_open_date_start" v-model="menu_open_date_start" :close-on-content-click="false" :return-value.sync="date_start" transition="scale-transition" offset-y min-width="auto">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field v-model="date_start_be" class="mr-1" label="วันที่เริ่มต้น (วัน/เดือน/ปี)" readonly v-bind="attrs" v-on="on" :rules="[v => !!v || 'กรุณากรอกวันที่เริ่มต้น']" required outlined></v-text-field>
                                            </template>
                                            <v-date-picker v-model="date_start" :max="date_end" no-title scrollable locale="th" :events="dateStartEndBE('date_start')">
                                                <v-spacer></v-spacer>
                                                <v-btn text color="primary" @click="dateStartEnd('date_start')">
                                                    ตกลง
                                                </v-btn>
                                                <v-btn text color="primary" @click="menu_open_date_start = false">
                                                    ยกเลิก
                                                </v-btn>
                                            </v-date-picker>
                                        </v-menu>
                                        <v-menu ref="menu_open_date_end" v-model="menu_open_date_end" :close-on-content-click="false" :return-value.sync="date_end" transition="scale-transition" offset-y min-width="auto">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field v-model="date_end_be" label="วันที่สิ้นสุด (วัน/เดือน/ปี)" readonly v-bind="attrs" v-on="on" :rules="[v => !!v || 'กรุณากรอกวันที่สิ้นสุด']" required outlined></v-text-field>
                                            </template>
                                            <v-date-picker v-model="date_end" class="ml-1" :min="date_start" no-title scrollable locale="th" :events="dateStartEndBE('date_end')">
                                                <v-spacer></v-spacer>
                                                <v-btn text color="primary" @click="dateStartEnd('date_end')">
                                                    ตกลง
                                                </v-btn>
                                                <v-btn text color="primary" @click="menu_open_date_end = false">
                                                    ยกเลิก
                                                </v-btn>
                                            </v-date-picker>
                                        </v-menu>
                                    </div>
                                    <v-textarea label="เหตุผลการลา" v-model="description" :rules="[v => !!v || 'กรุณากรอกเหตุผลการลา']" required outlined></v-textarea>
                                </v-col>

                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn class="grad-primary-bg white--text" height="50" width="50%" type="submit">
                            บันทึก
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
        <!-- แก้ไข -->
        <v-dialog v-model="open_edit_leave_work" persistent max-width="600px">
            <div v-if="loading_page_detail === true">
                <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                    <v-skeleton-loader type="article, actions"></v-skeleton-loader>
                </v-sheet>
            </div>
            <v-card v-if="loading_page_detail === false">
                <v-form ref="form_edit" @submit.prevent="editLeaveWork()">
                    <v-card-title class="justify-space-between">
                        <div>
                            แก้ไขฟอร์มขออนุญาติลา
                        </div>
                        <div class="cursor_leave_work_list" @click="open_edit_leave_work = false">
                            <v-icon>mdi-close</v-icon>
                        </div>
                    </v-card-title>

                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12">
                                    <div class="title_font_leave_work mb-2">
                                        ประเภทการลา
                                    </div>
                                    <div class="mb-2">
                                        <v-radio-group class="mt-0" v-model="type_leave" :rules="[v => !!v || 'กรุณาเลือกประเภทการลา']" required hide-details="auto">
                                            <div class="d-flex">
                                                <div class="d-flex">
                                                    <v-radio color="#038cc1" class="mb-0" value="1"></v-radio>
                                                    <div class="mr-1">ลากิจ</div>
                                                </div>
                                                <div class="d-flex mx-4">
                                                    <v-radio color="#038cc1" class="mb-0" value="2"></v-radio>
                                                    <div class="mr-1">ลาป่วย</div>
                                                </div>
                                                <div class="d-flex">
                                                    <v-radio color="#038cc1" class="mb-0" value="3"></v-radio>
                                                    <div class="mr-1">ลาคลอด</div>
                                                </div>

                                            </div>
                                        </v-radio-group>
                                    </div>
                                    <div class="title_font_leave_work mb-2">
                                        วันลา
                                    </div>
                                    <div class="grid_leave_work_list">
                                        <v-menu ref="menu_open_date_start_edit" v-model="menu_open_date_start_edit" :close-on-content-click="false" :return-value.sync="date_start_edit" transition="scale-transition" offset-y min-width="auto">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field v-model="date_start_edit_be" class="mr-1" label="วันที่เริ่มต้น (วัน/เดือน/ปี)" readonly v-bind="attrs" v-on="on" :rules="[v => !!v || 'กรุณากรอกวันที่เริ่มต้น']" outlined></v-text-field>
                                            </template>
                                            <v-date-picker v-model="date_start_edit" :max="date_end_edit" no-title scrollable locale="th" :events="dateStartEndBE('date_start_edit')">
                                                <v-spacer></v-spacer>
                                                <v-btn text color="primary" @click="dateStartEndEdit('date_start_edit')">
                                                    ตกลง
                                                </v-btn>
                                                <v-btn text color="primary" @click="menu_open_date_start_edit = false">
                                                    ยกเลิก
                                                </v-btn>
                                            </v-date-picker>
                                        </v-menu>
                                        <v-menu ref="menu_open_date_end_edit" v-model="menu_open_date_end_edit" :close-on-content-click="false" :return-value.sync="date_end_edit" transition="scale-transition" offset-y min-width="auto">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field v-model="date_end_edit_be" label="วันที่สิ้นสุด (วัน/เดือน/ปี)" readonly v-bind="attrs" v-on="on" :rules="[v => !!v || 'กรุณากรอกวันที่สิ้นสุด']" outlined></v-text-field>
                                            </template>
                                            <v-date-picker v-model="date_end_edit" class="ml-1" :min="date_start_edit" no-title scrollable locale="th" :events="dateStartEndBE('date_end_edit')">
                                                <v-spacer></v-spacer>
                                                <v-btn text color="primary" @click="dateStartEndEdit('date_end_edit')">
                                                    ตกลง
                                                </v-btn>
                                                <v-btn text color="primary" @click="menu_open_date_end_edit = false">
                                                    ยกเลิก
                                                </v-btn>
                                            </v-date-picker>
                                        </v-menu>
                                    </div>
                                    <v-textarea label="เหตุผลการลา" v-model="description" :rules="[v => !!v || 'กรุณากรอกเหตุผลการลา']" required outlined></v-textarea>
                                </v-col>

                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn color="#28ab28" class="white--text" height="50" width="50%" type="submit">
                            บันทึก
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
        <v-dialog v-model="open_confirm_delete" persistent max-width="600">
            <v-card>
                <v-card-title>
                    ลบการลางาน
                </v-card-title>

                <v-card-text>
                    ท่านต้องการลบการลางาน ใช่ หรือ ไม่ ?
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="success" height="50" @click="deleteLeaveWork()">
                        ตกลง
                    </v-btn>
                    <v-btn color="error" height="50" @click="open_confirm_delete = false">
                        ยกเลิก
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</div>
</template>

<script>
import leavework from '@/api/team/teamleavework/leavework.js'
export default {
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true,
            loading_page_detail: true,
            alert_show_add: false,
            alert_show_edit: false,
            alert_show_delete: false,
            open_confirm_delete: false,
            open_detail_leave_work: false,
            open_add_leave_work: false,
            open_edit_leave_work: false,
            sick_leave_num: 0,
            leave_num: 0,
            leave_givingbirth_num: 0,
            edit_id: null,
            type_leave: null,
            menu_open_date_start: false,
            menu_open_date_end: false,
            date_start_be: '',
            date_start: '',
            date_end_be: '',
            date_end: '',
            menu_open_date_start_edit: false,
            menu_open_date_end_edit: false,
            date_start_edit_be: '',
            date_start_edit: '',
            date_end_edit_be: '',
            date_end_edit: '',
            description: null,
            status_detail: null,
            search: '',
            headers: [{
                    text: '#',
                    align: 'start',
                    value: 'number',
                },
                {
                    text: 'การลา',
                    value: 'type'
                },
                {
                    text: 'วันลา (เริ่มต้น)',
                    align: 'date',
                    value: 'start_date'
                },
                {
                    text: 'วันลา (สิ้นสุด)',
                    align: 'date',
                    value: 'end_date'
                },
                {
                    text: 'หมายเหตุ',
                    value: 'description'
                },
                {
                    text: 'สถานะ',
                    value: 'status'
                },
                {
                    text: 'จัดการ',
                    value: 'action'
                },
            ],
            data: [],
        }
    },
    methods: {
        dateStartEndBE(type) {
            if (type == 'date_start') {
                if (this.date_start == '') {
                    this.date_start_be = ''
                }
                if (this.date_start) {
                    let date_arr = this.date_start.split('-')
                    let year = parseInt(date_arr[0]) + 543
                    let month = parseInt(date_arr[1]) - 1
                    month = this.$store.state.monthList[month].name_short
                    this.date_start_be = `${date_arr[2]}/${month}/${year}`
                }
            }
            if (type == 'date_end') {
                if (this.date_end == '') {
                    this.date_end_be = ''
                }
                if (this.date_end) {
                    let date_arr = this.date_end.split('-')
                    let year = parseInt(date_arr[0]) + 543
                    let month = parseInt(date_arr[1]) - 1
                    month = this.$store.state.monthList[month].name_short
                    this.date_end_be = `${date_arr[2]}/${month}/${year}`
                }
            }
            if (type == 'date_start_edit') {
                if (this.date_start_edit == '') {
                    this.date_start_edit_be = ''
                }
                if (this.date_start_edit) {
                    let date_arr = this.date_start_edit.split('-')
                    let year = parseInt(date_arr[0]) + 543
                    let month = parseInt(date_arr[1]) - 1
                    month = this.$store.state.monthList[month].name_short
                    this.date_start_edit_be = `${date_arr[2]}/${month}/${year}`
                }
            }
            if (type == 'date_end_edit') {
                if (this.date_end_edit == '') {
                    this.date_end_edit_be = ''
                }
                if (this.date_end_edit) {
                    let date_arr = this.date_end_edit.split('-')
                    let year = parseInt(date_arr[0]) + 543
                    let month = parseInt(date_arr[1]) - 1
                    month = this.$store.state.monthList[month].name_short
                    this.date_end_edit_be = `${date_arr[2]}/${month}/${year}`
                }
            }
        },
        async dateStartEnd(type) {
            if (type == 'date_start') {
                this.$refs.menu_open_date_start.save(this.date_start)
                let date_arr = this.date_start.split('-')
                let year = parseInt(date_arr[0]) + 543
                let month = parseInt(date_arr[1]) - 1
                month = this.$store.state.monthList[month].name_short
                this.date_start_be = `${date_arr[2]}/${month}/${year}`
                this.menu_open_date_start = false
            }
            if (type == 'date_end') {
                this.$refs.menu_open_date_end.save(this.date_end)
                let date_arr = this.date_end.split('-')
                let year = parseInt(date_arr[0]) + 543
                let month = parseInt(date_arr[1]) - 1
                month = this.$store.state.monthList[month].name_short
                this.date_end_be = `${date_arr[2]}/${month}/${year}`
                this.menu_open_date_end = false
            }
        },
        async dateStartEndEdit(type) {
            if (type == 'date_start_edit') {
                this.$refs.menu_open_date_start_edit.save(this.date_start_edit)
                let date_arr = this.date_start_edit.split('-')
                let year = parseInt(date_arr[0]) + 543
                let month = parseInt(date_arr[1]) - 1
                month = this.$store.state.monthList[month].name_short
                this.date_start_edit_be = `${date_arr[2]}/${month}/${year}`
                this.menu_open_date_start_edit = false
            }
            if (type == 'date_end_edit') {
                this.$refs.menu_open_date_end_edit.save(this.date_end_edit)
                let date_arr = this.date_end_edit.split('-')
                let year = parseInt(date_arr[0]) + 543
                let month = parseInt(date_arr[1]) - 1
                month = this.$store.state.monthList[month].name_short
                this.date_end_edit_be = `${date_arr[2]}/${month}/${year}`
                this.menu_open_date_end_edit = false
            }
        },
        async leaveWorkList() {
            this.loading_page = true
            this.sick_leave_num = 0
            this.leave_num = 0
            leavework.leaveWorkList().then((response) => {
                if (response.data.successful === true) {
                    this.leave_num = response.data.leave_work
                    this.sick_leave_num = response.data.leave_sick
                    this.leave_givingbirth_num = response.data.leave_givingbirth
                    this.data = response.data.leave
                    response.data.leave.forEach((detail, index) => {
                        this.data[index]['number'] = index + 1
                        this.data[index]['type'] = detail.type == 1 ? 'ลากิจ' : detail.type == 2 ? 'ลาป่วย' : detail.type == 3 ? 'ลาคลอด' : ''
                        this.data[index]['status'] = detail.status == 1 ? 'รออนุมัติ' : detail.status == 2 ? 'อนุมัติ' : detail.status == 3 ? 'ไม่อนุมัติ' : ''
                    })
                    this.loading_page = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async openDetailLeaveWork(id) {
            this.type_leave = null
            this.date_start_edit_be = ''
            this.date_start_edit = ''
            this.date_end_edit_be = ''
            this.date_end_edit = ''
            this.description = null
            this.status_detail = null
            this.loading_page_detail = true
            this.open_detail_leave_work = true
            leavework.detailLeaveWork(id).then((response) => {
                if (response.data.successful === true) {
                    this.type_leave = response.data.detail.type.toString()
                    this.date_start_edit_be = response.data.detail.start_date_be
                    this.date_start_edit = response.data.detail.start_date
                    this.date_end_edit_be = response.data.detail.end_date_be
                    this.date_end_edit = response.data.detail.end_date
                    this.description = response.data.detail.description
                    this.status_detail = response.data.detail.status
                    this.loading_page_detail = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async openAddLeaveWork() {
            this.type_leave = null
            this.date_start_be = ''
            this.date_start = ''
            this.date_end_be = ''
            this.date_end = ''
            this.description = null
            this.open_add_leave_work = true
        },
        async addLeaveWork() {
            if (this.$refs.form_add.validate()) {
                this.loading_page = false
                this.open_add_leave_work = false
                const data = {
                    type: this.type_leave,
                    start_date: this.date_start,
                    end_date: this.date_end,
                    description: this.description,
                }
                leavework.addLeaveWork(data).then((response) => {
                    if (response.data.successful === true) {
                        this.type_leave = null
                        this.date_start_be = ''
                        this.date_start = ''
                        this.date_end_be = ''
                        this.date_end = ''
                        this.description = null
                        this.leaveWorkList()
                        this.alert_show_add = true
                        setTimeout(() => this.alert_show_add = false, 5000)
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
            }
        },
        async openEditLeaveWork(id) {
            this.edit_id = null
            this.type_leave = null
            this.date_start_edit_be = ''
            this.date_start_edit = ''
            this.date_end_edit_be = ''
            this.date_end_edit = ''
            this.description = null
            this.loading_page_detail = true
            this.open_edit_leave_work = true
            leavework.detailLeaveWork(id).then((response) => {
                if (response.data.successful === true) {
                    this.edit_id = response.data.detail.id
                    this.type_leave = response.data.detail.type.toString()
                    this.date_start_edit = response.data.detail.start_date
                    this.date_end_edit = response.data.detail.end_date
                    this.description = response.data.detail.description
                    this.loading_page_detail = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async editLeaveWork() {
            if (this.$refs.form_edit.validate()) {
                this.loading_page = false
                this.open_edit_leave_work = false
                const data = {
                    type: this.type_leave,
                    start_date: this.date_start_edit,
                    end_date: this.date_end_edit,
                    description: this.description,
                }
                leavework.editLeaveWork(this.edit_id, data).then((response) => {
                    if (response.data.successful === true) {
                        this.edit_id = null
                        this.type_leave = null
                        this.date_start_edit_be = ''
                        this.date_start_edit = ''
                        this.date_end_edit_be = ''
                        this.date_end_edit = ''
                        this.description = null
                        this.leaveWorkList()
                        this.alert_show_edit = true
                        setTimeout(() => this.alert_show_edit = false, 5000)
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
            }
        },
        async openDeleteLeaveWork(id) {
            this.edit_id = id
            this.open_confirm_delete = true
        },
        async deleteLeaveWork() {
            this.open_confirm_delete = false
            this.loading_page = true
            leavework.deleteLeaveWork(this.edit_id).then((response) => {
                if (response.data.successful === true) {
                    this.edit_id = null
                    this.type_leave = null
                    this.date_start_edit_be = ''
                    this.date_start_edit = ''
                    this.date_end_edit_be = ''
                    this.date_end_edit = ''
                    this.description = null
                    this.leaveWorkList()
                    this.alert_show_delete = true
                    setTimeout(() => this.alert_show_delete = false, 5000)
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        }
    },
    mounted() {
        this.leaveWorkList()
    }
}
</script>

<style scoped>
.grid_leave_work_list {
    display: grid;
    grid-template-columns: 50% 50%;
}

.title_font_leave_work {
    font-size: 20px;
}

.cursor_leave_work_list {
    cursor: pointer;
}

.height_full_detail_leave_work_list {
    height: 100%;
    background: #eeeeee;
    border-radius: 10px;
    padding: 10px;
    color: #000000;
}
</style>
